<template>
  <div>
    <div
      class="background mb-2"
      :style="{ backgroundImage: `url(${invite.background})` }"
      v-if="invite.background"
    >
      <b-container>
        <div class="title text-center text-lg-left">
          {{ invite.title }}
        </div>
        <div
          class="d-flex flex-column flex-lg-row justify-content-between align-items-center"
        >
          <div class="d-flex flex-column font-weight-bold mb-3 mb-lg-0">
            <div class="mb-2">
              마감일:
              {{ $moment(invite.closed).format("ll") }}
            </div>
          </div>
        </div>
      </b-container>
    </div>
    <b-container>
      <b-row>
        <b-col>
          <b-form class="mb-2" @submit.prevent="submit">
            <b-form-group
              :key="question.id"
              :label="question.question"
              v-for="(question, index) in questions.results"
            >
              <b-form-textarea maxlength="250" v-model="answers[index].answer">
              </b-form-textarea>
            </b-form-group>

            <b-form-group>
              <b-form-checkbox-group>
                <b-form-checkbox v-model="agreement">
                  I agree to the Guidelines,
                  <a href="" target="_blank">Official Rules</a>, and
                  <a href="" target="_blank">Terms & Conditions</a>.
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>

            <b-button class="mr-2" to="/">Cancel</b-button>
            <b-button type="submit" :disabled="!agreement" variant="primary"
              >Submit</b-button
            >
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import UnloadMixin from "../mixins/UnloadMixin";
import {
  Invite,
  InviteApplication,
  InviteQuestion,
  InviteAnswer
} from "../models";

export default {
  mixins: [UnloadMixin],
  props: ["inviteId", "artworkId"],
  data() {
    return {
      invite: new Invite({
        id: this.inviteId
      }),
      application: new InviteApplication({
        invite: this.inviteId,
        artwork: this.artworkId
      }),
      questions: {
        results: []
      },
      answers: [],
      agreement: false
    };
  },
  async created() {
    this.invite = await this.invite.load();
    this.questions = await new InviteQuestion().get({
      invite: this.invite.id
    });
    this.answers = this.questions.results.map(q => {
      return new InviteAnswer({
        question: q.id,
        answer: ""
      });
    });
  },
  methods: {
    async submit() {
      document.body.classList.add("loading-open");
      try {
        this.application = await this.application.save();

        await Promise.all(
          this.answers.map(answer => {
            answer.application = this.application.id;
            return answer.save();
          })
        );
      } finally {
        document.body.classList.remove("loading-open");
      }

      this.$router.push({
        name: "application-complete-with-artwork",
        params: {
          inviteId: this.inviteId,
          artworkId: this.artworkId,
          force: true
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.background {
  position: relative;
  padding: 30px;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    opacity: 0.5;
    z-index: -1;
  }
}

.title {
  font-size: 30px;
  font-weight: bold;
}
</style>
